/**
 * Created by - Ashish Dewangan on 08-07-2024
 * Reason - To have header component
 */
import React, { useContext, useEffect, useState } from "react";
import headerStyle from "./header.module.css";
import config from "../../Api/config";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import TopHeader from "./TopHeader";
import { GiHamburgerMenu } from "react-icons/gi";
import { Drawer } from "antd";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdDownload } from "react-icons/md";
import { MdArrowDropDown } from "react-icons/md";
// import topHeaderStyle from "../Header/topHeader.module.css";
import { FaMobileAlt } from "react-icons/fa";
// import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { IoMdCall } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { IoCallOutline } from "react-icons/io5";
import { HiOutlineMail } from "react-icons/hi";
import { IoHome } from "react-icons/io5";
import { GrHomeRounded } from "react-icons/gr";
import Marquee from "react-fast-marquee";

const Header = () => {
  // Added by - Ashlekh on 10-09-2024
  // Reason - To fix header size dynamically (when user scrolls in page)
  // const [headerSize, setHeaderSize] = useState("22vh");
  // End of code - Ashlekh on 10-09-2024
  // Reason - To fix header size dynamically (when user scrolls in page)
  const { user, setUser, settingDetail } = useContext(GlobalContext);
  // const [logo, setLogo] = useState("");
  // const navigate = useNavigate();
  // Added by - Ashlekh on 23-08-2024
  // Reason - To have useState for highlighting header
  const [activeLink, setActiveLink] = useState("");
  // End of code - Ashlekh on 23-08-2024
  // Reason - To have useState for highlighting header

  //Added by -Jhamman Lal Sahu on 29-07-2024
  // Reason - To get the location of current page

  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");

  const [isOpen, setIsOpen] = React.useState(false); //Addition by Om on 12-08-2024 because handle the antd drawer

  const [showSubmenu1, setShowSubmenu1] = useState(false); //Addition by on 12-08-2024 because open the nested menus
  const [showSubmenu2, setShowSubmenu2] = useState(false); //Addition by on 12-08-2024 because open the nested menus
  const [showSubmenu3, setShowSubmenu3] = useState(false); //Addition by on 29-08-2024 because open the nested menus

  const [showSubmenu4, setShowSubmenu4] = useState(false);

  useEffect(() => {
    setCurrentPath(location.pathname);

    setActiveLink(location.pathname);
  }, [location.pathname]);

  const [colorChange, setColorChange] = useState(" ");
  const [topHeaderVisibility, setTopHeaderVisibility] = useState(" ");
  useEffect(() => {
    const changeNavbarColor = () => {
      if (window.scrollY >= 120) {
        setColorChange("var(--header-background-image)");

        setTopHeaderVisibility("none");
      } else {
        setColorChange("var(--transparent-background)");

        setTopHeaderVisibility("flex");
      }
    };
    window.addEventListener("scroll", changeNavbarColor);
    return () => {
      window.removeEventListener("scroll", changeNavbarColor);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    getHeaderLogo();
  }, []);

  const getHeaderLogo = async () => {};

  const closeDrawer = () => {
    setIsOpen((prevState) => !prevState);

    setShowSubmenu1(false);
    setShowSubmenu2(false);
    setShowSubmenu3(false);
    setShowSubmenu4(false);
  };

  return (
    <div className={`${headerStyle.header} `}>
      <div
        className={headerStyle.topHeaderContainer}
        style={
          currentPath == "/"
            ? { display: topHeaderVisibility }
            : { display: topHeaderVisibility }
        }
      >
        <TopHeader />
      </div>
      <div className={`${headerStyle.mainHeaderContainer}  `}>
        <div className={`${headerStyle.iconContainer} `}>
          <GiHamburgerMenu
            onClick={closeDrawer}
            className={`${headerStyle.button}`}
          />
        </div>

        <Drawer
          headerStyle={{
            backgroundImage: "var(--main-header-background-image)",
            display: "flex",
          }}
          open={isOpen}
          onClose={closeDrawer}
          placement="right"
          className={`${headerStyle.hamburgerDrawer}`}
          title="Adyant SoftTech"
          width={280}
        >
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
            className={`${headerStyle.drawerMenu}}`}
          >
            <li className={headerStyle.li}>
              <Link onClick={closeDrawer} to="/" className={headerStyle.link}>
                Home
              </Link>
            </li>

            <hr className={`${headerStyle.horizontalLine}`} />
            <li className={headerStyle.li}>
              <Link
                onClick={() => setShowSubmenu2(!showSubmenu2)}
                style={{ textDecoration: "none", color: "black" }}
                className={headerStyle.link}
              >
                Company Profile
                {showSubmenu2 ? (
                  <FaChevronUp className={headerStyle.icon} />
                ) : (
                  <FaChevronDown className={headerStyle.icon} />
                )}
              </Link>

              {showSubmenu2 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu2(false);
                        closeDrawer();
                      }}
                      to="/company_profile/about_us"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      About Us
                    </Link>
                  </li>

                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu2 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu2(false);
                        closeDrawer();
                      }}
                      to="/company_profile/mission-vision"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      Mission Vision
                    </Link>
                  </li>

                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}

              {showSubmenu2 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu2(false);
                        closeDrawer();
                      }}
                      to="/company_profile/why-us"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      Why us
                    </Link>
                  </li>

                  {/* <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  /> */}
                </div>
              )}
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />

            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/services"
                className={headerStyle.link}
              >
                Services
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            {/* End of code - Ashlekh on 20-12-2024
            Reason - To add services and certificates */}
            {/* Added by - Ashlekh on 04-02-2025
            Reason - To add global presence page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/global-presence"
                className={headerStyle.link}
              >
                Global Presence
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            {/* End of code - Ashlekh on 04-02-2025
            Reason - To add global presence page */}
            {/* Added by - Ashlekh on 13-02-2025
            Reason - To add Research and development page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/research-and-development"
                className={headerStyle.link}
              >
                R&D
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            {/* End of code - Ashlekh on 13-02-2025
            Reason - To add Research and development page */}
            {/* Added by - Sameer on 07-11-2025
          Reason - To add product page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/products"
                className={headerStyle.link}
              >
                Products
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            {/* End of code - Sameer on 07-11-2025
          Reason - To add product page */}
            {/* Added by - Ashlekh on 26-12-2024
            Reason - To add R&D page and global presence page*/}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/news"
                className={headerStyle.link}
              >
                News / Letter
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />

            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/blog"
                className={headerStyle.link}
              >
                Blog / Case Studies
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/client_testimonials"
                className={headerStyle.link}
              >
                Client Testimonials
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            {/* End of code - Ashlekh on 26-12-2024
            Reason - To add R&D page and global presence page*/}
            {/* Commented by - Jhamman on 29-08-2024
                Reason - i create service dropdown below */}
            {/* <li className={headerStyle.li}>
              <div>
                <img
                  style={{ width: "6.5vw" }}
                  src="donation_drawer_img.png"
                  alt=""
                />
              </div>
              <Link
                // onClick={closeDrawer}
                // to="/donation"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}>
                Services
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li> */}
            {/* End of commentation by - Jhamman on 29-08-2024
                Reason - i create service dropdown below */}

            {/* Added by - jhamman on 29-08-2024
            Reason - to add service dropdown */}

            {/* <li className={headerStyle.li}>
              <Link
                className={headerStyle.link}
                onClick={() => setShowSubmenu3(!showSubmenu3)}
                style={{ textDecoration: "none", color: "black" }}>
                Services
                {showSubmenu3 ? (
                  <FaChevronUp className={headerStyle.icon} />
                ) : (
                  <FaChevronDown className={headerStyle.icon} />
                )}
              </Link>
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/contract-manufacturing"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      Contract Manufacturing
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/third-party-manufacturing"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      Third Party Manufacturing
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/institutional-tenders"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      Institutional Tenders
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/generic-medicines"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      Generic Medicines
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/otc-products"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      OTC Products
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/regulatory-services"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      Regulatory Services
                    </Link>
                  </li>
                  <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  />
                </div>
              )}
              {showSubmenu3 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu3(false);
                        closeDrawer();
                      }}
                      to="/services/quality-control-quality-assurance"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}>
                      QC&QA
                    </Link>
                  </li>
                </div>
              )}
            </li> */}
            {/* <hr className={`${headerStyle.horizontalLine}`} /> */}

            {/* End of addition by Jhamman on 29-08-2024
            Reason - to add service dropdown */}

            <li className={headerStyle.li}>
              {/* <div>
                <img
                  style={{ width: "6.5vw" }}
                  src="donation_drawer_img.png"
                  alt=""
                />
              </div> */}
            </li>

            {/* Added by - Ashlekh on 17-08-2024
            Reason - To add Gallery Blog Career Texfer and Contact Us */}
            <li className={headerStyle.li}>
              <Link
                /**
                 * Added by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                onClick={closeDrawer}
                /**
                 * End of code addition by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                to="/gallery"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Gallery
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>

            {/* Added by - Ashlekh on 04-02-2025
            Reason - To add Event page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/event"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Event
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* End of code - Ashlekh on 04-02-2025
            Reason - To add Event page */}
            <li className={headerStyle.li}>
              <Link
                /**
                 * Added by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                onClick={closeDrawer}
                /**
                 * End of code addition by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                to="/registration"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Registration
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/career"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Career
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/certificates"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Certificates
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>

            {/* <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/privacy-policy"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Privacy Policy
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li> */}

            {/* <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/socialicons"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Social Media Details
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li> */}
            {/* <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/texfer"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}>
                Texfer
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li> */}
            <li className={headerStyle.li}>
              <Link
                /**
                 * Added by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                // onClick={closeDrawer}
                onClick={() => setShowSubmenu4(!showSubmenu4)}
                /**
                 * End of code addition by - Ashish Dewangan on 23-08-2024
                 * Reason - To close the drawer when we click on header link
                 */
                style={{ textDecoration: "none", color: "black" }}
                className={headerStyle.link}
              >
                Contact Us
                {/* End of commentation by jhamman on 21-09-2024
                Reason - changed name*/}
                {showSubmenu4 ? (
                  <FaChevronUp className={headerStyle.icon} />
                ) : (
                  <FaChevronDown className={headerStyle.icon} />
                )}
              </Link>

              {showSubmenu4 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu4(false);
                        closeDrawer();
                      }}
                      to="/contact/india"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      Contact us India
                    </Link>
                  </li>

                  {/* <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  /> */}
                </div>
              )}
              {showSubmenu4 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu4(false);
                        closeDrawer();
                      }}
                      to="/contact/us"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      {/* Contact us US */}
                      Contact us United State of America
                    </Link>
                  </li>

                  {/* <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  /> */}
                </div>
              )}
              {showSubmenu4 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu4(false);
                        closeDrawer();
                      }}
                      to="/contact/uk"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      {/* Contact us UK */}
                      Contact us United Kingdom
                    </Link>
                  </li>

                  {/* <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  /> */}
                </div>
              )}

              {showSubmenu4 && (
                <div>
                  <li className={headerStyle.submenuLi}>
                    <Link
                      onClick={() => {
                        setShowSubmenu4(false);
                        closeDrawer();
                      }}
                      to="/contact/newzealand"
                      className={`${headerStyle.subLink}`}
                      style={{ padding: "9px 10px 9px 25px" }}
                    >
                      Contact us New Zealand
                    </Link>
                  </li>

                  {/* <hr
                    className={`${headerStyle.dropdownElementsHorizontalLine}`}
                  /> */}
                </div>
              )}
            </li>
            {/* End of code - Ashlekh on 17-08-2024
            Reason - To add Gallery Blog Career Texfer and Contact Us */}

            {/*
             * Added by - Ashish Dewangan on 23-08-2024
             * Reason - Added download brochure button
             */}
            {settingDetail.brochure &&
              settingDetail.brochure?.trim()?.length > 0 && (
                <li className={`${headerStyle.li}`}>
                  <Link
                    onClick={closeDrawer}
                    className={`${headerStyle.link}`}
                    to={`${config.baseURL}${settingDetail?.brochure}`}
                    target="_blank"
                  >
                    {/* Download brochure */}
                    Download Brochure
                    <MdDownload
                      className={`${headerStyle.downloadBroucherIconForDrawer}`}
                      style={{ fontSize: "25px" }}
                    />
                  </Link>
                  <hr className={`${headerStyle.horizontalLine}`} />
                </li>
              )}

            {/*
             * End of addition by - Ashish Dewangan on 23-08-2024
             * Reason - Added download brochure button
             */}
          </ul>
        </Drawer>
        {/* End of addition by Om Shrivastava on 12-08-2024
        Reason : Add the drawer  */}

        {/* Addition by Jhamman on 14-09-2024
          Reason - Added mobile number and email in main header in mobile view*/}

        <div className={`${headerStyle.contactContainer}`}>
          <Marquee>
            {/* {settingDetail?.career_contact_number ? (
              <div className={headerStyle.contacts}>
                <IoMdCall className={headerStyle.callIcon} />
                <b
                  className={headerStyle.titleOfContacts}
                  style={{ fontWeight: "500", }}>
                  For Career :
                </b>
                <span>{settingDetail?.career_number}</span>
              </div>
            ) : null} */}

            {/* {settingDetail?.email ? (
            <div className={headerStyle.contacts}>
              <MdEmail className={headerStyle.emailIcon} />
              <span>{settingDetail?.email}</span>
            </div>
          ) : null} */}

            {settingDetail?.business_contact_number ? (
              <div className={headerStyle.contacts}>
                <IoMdCall className={headerStyle.callIcon} />
                <b
                  className={headerStyle.titleOfContacts}
                  style={{ fontWeight: "500" }}
                >
                  {/* For Business : */}
                  Contact Number
                </b>
                {/* Code changed by - Ashlekh on 10-11-2024
                Reason - To remove +91 */}
                {/* <span>+91-{settingDetail?.business_contact_number}</span> */}
                <span>{settingDetail?.business_contact_number}</span>
                {/* End of code - Ashlekh on 10-11-2024
                Reason - To remove +91 */}
              </div>
            ) : null}

            {settingDetail?.email || settingDetail?.second_email ? (
              <div className={headerStyle.contacts}>
                <MdEmail className={headerStyle.emailIcon} />
                <b
                  className={headerStyle.titleOfContacts}
                  style={{ fontWeight: "500" }}
                >
                  Email :
                </b>
                <span> {settingDetail?.email}</span>
                {settingDetail?.email ? <> || </> : null}
                <span> {settingDetail?.second_email}</span>
              </div>
            ) : null}
          </Marquee>
        </div>

        {/* End of addition by Jhamman on 14-09-2024
          Reason - Added mobile number and email in main header in mobile view*/}

        <div className={`${headerStyle.navbar} `}>
          {/* Modified by Jhamman on 05-09-2024
          Reason - to show activation of this nav Item */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/"
              // className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}>
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/" && headerStyle.active}`}
            >
              {/* Home */}
              <IoHome style={{ height: "20px", width: "20px" }} />
            </Link>
          </div>
          {/* End of modification by Jhamman on 05-09-2024
          Reason - to show activation of this nav Item*/}

          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${
              headerStyle.navbarFont
            }
            ${activeLink.startsWith("/infrastructure") && headerStyle.active}`}>
            Infrastructure
            <MdArrowDropDown style={{ height: 20, width: 20, marginLeft: 8 }} />
            <div className={`${headerStyle.dropdown}`}>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/infrastructure/manufacturing"
                  className={`${headerStyle.subLink}`}>
                  Manufacturing
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/infrastructure/packaging"
                  className={`${headerStyle.subLink}`}>
                  Packaging
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/infrastructure/research-and-development"
                  className={`${headerStyle.subLink}`}>
                  R&D
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/infrastructure/accreditation"
                  className={`${headerStyle.subLink}`}>
                  Accreditation
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/infrastructure/quality-control"
                  className={`${headerStyle.subLink}`}>
                  Quality Control
                </Link>
              </li>
            </div>
          </div> */}
          {/* Added by - Ashlekh on 20-12-2024
          Reason - To add R&D options in header*/}
          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}>
            <Link
              to="/research-and-development"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/research-and-development" && headerStyle.active}`}>
              R&D
            </Link>
          </div> */}
          {/* End of code - Ashlekh on 20-12-2024
          Reason - To add R&D options in header*/}

          {/* Added by - Ashlekh on 01-08-2024
          Reason - To add company profile option */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${
              headerStyle.navbarFont
            }
            ${activeLink.startsWith("/company_profile") && headerStyle.active}`}
          >
            Company Profile
            {/* Modified by Jhamman on 05-09-2024
                  Reason- Added margin left */}
            {/* Added by - Jhamman lal sahu on 26-08-2024
            Reason - to add arrow icon */}
            {/* <MdArrowDropDown style={{ height: 20, width: 20 }} /> */}
            <MdArrowDropDown style={{ height: 20, width: 20, marginLeft: 8 }} />
            {/* End of addition by - Jhamman lal sahu on 26-08-2024
            Reason - to add arrow icon */}
            {/* End of modification by Jhamman on 05-09-2024
                  Reason- Added margin left */}
            <div className={`${headerStyle.dropdown}`}>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/about_us"
                  /*Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  {/* Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink */}
                  About Us
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/mission-vision"
                  /*Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  {/* Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink */}
                  Mission Vision
                </Link>
              </li>

              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/why-us"
                  /*Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  {/* Modified by Jhamman on 04-09-2024
                  Reason- Changed css from link to subLink */}
                  Why Us
                </Link>
              </li>
              {/* <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/business-value"
                  className={`${headerStyle.subLink}`}>
                  Business Value
                </Link>
              </li> */}
              {/* <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/management"
                  className={`${headerStyle.subLink}`}>
                  Management
                </Link>
              </li> */}

              {/* <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/quality-policy"
                  className={`${headerStyle.subLink}`}>
                  Quality Policy
                </Link>
              </li> */}
              {/* <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/company_profile/client-satisfaction"
                  className={`${headerStyle.subLink}`}>
                  Client Satisfaction
                </Link>
              </li> */}
            </div>
          </div>
          {/* End of code - Ashlekh on 01-08-2024
          Reason - To add company profile option  */}

          {/* 
          Added by - Ashish Dewangan on 07-08-2024
          Reason - Added global presence meny to header links */}
          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}>
            <Link
              to="/global-presence"
              // Modified by Jhamman on 04-09-2024
              // Reason - Because previously its not highlighted on header
              // className={`${headerStyle.link}
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/global-presence" && headerStyle.active}`}>
              Global Presence
            </Link>
          </div> */}
          {/* 
          End of code addition by - Ashish Dewangan on 07-08-2024
          Reason - Added global presence meny to header links */}

          {/* Added by - Jhamman lal sahu on 05-08-2024
            Reason - Add a new item Services in NavBar */}
          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${
              headerStyle.navbarFont
            }
            ${activeLink.startsWith("/services") && headerStyle.active}`}>
            Services
            <MdArrowDropDown style={{ height: 20, width: 20, marginLeft: 8 }} />
            <div className={`${headerStyle.dropdown}`}>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/contract-manufacturing"
                  className={`${headerStyle.subLink}`}>
                  Contract Manufacturing
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/third-party-manufacturing"
                  className={`${headerStyle.subLink}`}>
                  3rd Party Manufacturing
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/institutional-tenders"
                  className={`${headerStyle.subLink}`}>
                  Institutional Tenders
                </Link>
              </li>

              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/generic-medicines"
                  className={`${headerStyle.subLink}`}>
                  Generic Medicines
                </Link>
              </li>

              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/otc-products"
                  className={`${headerStyle.subLink}`}>
                  OTC Products
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/regulatory-services"
                  className={`${headerStyle.subLink}`}>
                  Regulatory Services
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/services/quality-control-quality-assurance"
                  className={`${headerStyle.subLink}`}>
                  QC&QA
                </Link>
              </li>
            </div>
          </div> */}
          {/* Added by - Ashlekh on 20-12-2024
          Reason - To add Services and certificates */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/services"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/services" && headerStyle.active}`}
            >
              Services
            </Link>
          </div>

          {/* Added by - Ashlekh on 04-02-2025
          Reason - To add global presence */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/global-presence"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/global-presence" && headerStyle.active}`}
            >
              Global Presence
            </Link>
          </div>
          {/* End of code - Ashlekh on 04-02-2025
          Reason - To add global presence page */}
          {/* Added by - Ashlekh on 13-02-2025
          Reason - To add R&D page */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/research-and-development"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${
                activeLink == "/research-and-development" && headerStyle.active
              }`}
            >
              R&D
            </Link>
          </div>
          {/* End of code - Ashlekh on 13-02-2025
          Reason - To add R&D page */}
          {/* Added by - Sameer on 07-11-2025
          Reason - To add product page */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/products"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/products" && headerStyle.active}`}
            >
              Products
            </Link>
          </div>
          {/* End of code - Sameer on 07-11-2025
          Reason - To add product page */}

          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/news"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/news" && headerStyle.active}`}
            >
              News / Letter
            </Link>
          </div>

          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/blog"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/blog" && headerStyle.active}`}
            >
              Blog / Case Studies
            </Link>
          </div>

          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/client_testimonials"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/client_testimonials" && headerStyle.active}`}
            >
              Client Testimonials
            </Link>
          </div>
          {/* End of code - Ashlekh on 26-12-2024
          Reason - To add Research and development page and Global presence page*/}
          {/* Added by - Om Shrivastava on 03-08-2024
          Reason - To add Product option */}

          {/* End of code - Om Shrivastava on 03-08-2024
          Reason - To add Product option  */}

          {/* 
                Added by -Jhamman lal sahu on 09-08-2024
                Reason - to add new item Events in navbar */}

          {/* 
                End of the addition by -Jhamman lal sahu on 09-08-2024
                Reason - to add new item Events in navbar */}
          {/* End of Addition by Jhamman lal Sahu on 28-07-2024
          Reason - Create a NavBar */}
          {/* Commented by - Ashish Dewangan on 05-08-2024
          Reason - Logout button is not required in this project */}
          {/* {user && user.email && (
            <div
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              LOGOUT
            </div>
          )} */}
          {/* End of comment by - Ashish Dewangan on 05-08-2024
          Reason - Logout button is not required in this project */}

          {/* Added by - Ashlekh on 12-08-2024
            Reason - To have Blog & Gallery section */}
          <div
            // Added by - Ashlekh on 23-08-2024
            // Reason - For styling of header
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
            // End of code - Ashlekh on 23-08-2024
            // Reason - For styling of header
          >
            <Link
              to="/gallery"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/gallery" && headerStyle.active}`}
            >
              Gallery
            </Link>
          </div>
          {/* Added by - Ashlekh on 04-02-2025
          Reason - To add Event page */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/event"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/event" && headerStyle.active}`}
            >
              Event
            </Link>
          </div>
          {/* End of code - Ashlekh on 04-02-2025
          Reason - To add Event page */}
          <div
            // Added by - Ashlekh on 23-08-2024
            // Reason - For styling of header
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
            // End of code - Ashlekh on 23-08-2024
            // Reason - For styling of header
          >
            <Link
              to="/registration"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/registration" && headerStyle.active}`}
            >
              Registration
            </Link>
          </div>
          {/* End of code - Ashlekh on 12-08-2024
          Reason - To have Gallery & Blog section  */}
          {/* Added by - Ashlekh on 13-08-2024
          Reason - To have Career section */}
          <div
            // Added by - Ashlekh on 23-08-2024
            // Reason - For styling of header
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
            // End of code - Ashlekh on 23-08-2024
            // Reason - For styling of header
          >
            <Link
              to="/career"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/career" && headerStyle.active}`}
            >
              Career
            </Link>
          </div>

          {/* <div
            // Added by - Ashlekh on 23-08-2024
            // Reason - For styling of header
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
            // End of code - Ashlekh on 23-08-2024
            // Reason - For styling of header
          >
            <Link
              to="/privacy-policy"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/privacy-policy" && headerStyle.active}`}
            >
              Privacy Policy
            </Link>
          </div> */}

          {/* Added by - Sameer on 8-11-2025
          Reason - To have certifcates section */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/certificates"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              } ${activeLink === "/certificates" && headerStyle.active}`}
            >
              Certificates
            </Link>
          </div>
          {/* End of code - Sameer on 8-11-2025
          Reason - To have certifcates section */}
          {/* <div
            // Added by - Ashlekh on 23-08-2024
            // Reason - For styling of header
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
            // End of code - Ashlekh on 23-08-2024
            // Reason - For styling of header
          >
            <Link
              to="/socialicons"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/socialicons" && headerStyle.active}`}
            >
              Social Media Details
            </Link>
          </div> */}
          {/* End of code - Ashlekh on 13-08-2024
          Reason - To have Career section */}
          {/* Added by - Ashlekh on 14-08-2024
          Reason - To have Texfer section */}
          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer", }}
          >
            <Link
              to="/texfer"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/texfer" && headerStyle.active}`}>
              Texfer
            </Link>
          </div> */}
          {/* End of code - Ashlekh on 14-08-2024
          Reason - To have Texfer section */}
          {/* Added by - Ashlekh on 17-08-2024
          Reason - To have contact us section */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${
              headerStyle.navbarFont
            }
            ${activeLink.startsWith("/contact") && headerStyle.active}`}
          >
            Contact Us
            <MdArrowDropDown style={{ height: 20, width: 20, marginLeft: 8 }} />
            <div className={`${headerStyle.dropdown}`}>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/contact/india"
                  /*Modified by Jhamman on 04-09-2024
                    Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  Contact us India
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/contact/us"
                  /*Modified by Jhamman on 04-09-2024
                    Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  {/* Contact us US */}
                  Contact us United State of America
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/contact/newzealand"
                  /*Modified by Jhamman on 04-09-2024
                    Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  Contact us New Zealand
                </Link>
              </li>
              <li className={`${headerStyle.dropdownItem}`}>
                <Link
                  to="/contact/uk"
                  /*Modified by Jhamman on 04-09-2024
                    Reason- Changed css from link to subLink*/
                  // className={`${headerStyle.link}`}>
                  className={`${headerStyle.subLink}`}
                >
                  {/* Contact us UK */}
                  Contact us United Kingdom
                </Link>
              </li>
            </div>
          </div>

          {/* End of code - Ashlekh on 17-08-2024
          Reason - To have contact us section */}

          {/*
           * Added by - Ashish Dewangan on 23-08-2024
           * Reason - Added download brochure button
           */}
          {settingDetail.brochure &&
            settingDetail.brochure?.trim()?.length > 0 && (
              <div
                // className={`${headerStyle.downloadBrochure}`}
                className={`${headerStyle.downloadBrochure}`}
              >
                <Link
                  // Commented by - Ashlekh on 27-08-2024
                  // Reason - Drawer opens in desktop view
                  // onClick={closeDrawer}
                  // End of comment - Ashlekh on 27-08-2024
                  // Reason - Drawer opens in desktop view
                  className={`${headerStyle.downloadBrochureButton}`}
                  // className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
                  // className={`${headerStyle.link}`}
                  to={`${config.baseURL}${settingDetail?.brochure}`}
                  target="_blank"
                  // Commented by - Jhamman on 06-09-2024
                  // Reason - define it externally
                  // style={{
                  //   display: "flex",
                  //   alignItems: "center",
                  //   alignContent: "baseline",
                  //   lineHeight: "0px",
                  // }}
                  // End of commentation by - Jhamman on 06-09-2024
                  // Reason - define it externally
                >
                  <div className={`${headerStyle.downloadBroucherText}`}>
                    Download Brochure
                  </div>

                  {/* Modified by Jhamman on 27-09-2024
                  Reason - Added classname*/}
                  {/* <MdDownload style={{ fontSize: "25px" }} /> */}
                  <MdDownload
                    className={`${headerStyle.downloadBroucherIcon}`}
                    style={{ fontSize: "25px" }}
                  />
                  {/* End of modification by Jhamman on 27-09-2024
                  Reason - Added classname*/}
                </Link>
              </div>
            )}

          {/*
           * End of addition by - Ashish Dewangan on 23-08-2024
           * Reason - Added download brochure button
           */}
        </div>
      </div>
    </div>
  );
};

export default Header;
